const screen1 = require('./screen 1.png')
const screen2 = require('./screen 2.png')
const screen3 = require('./screen 3.png')
const screen4 = require('./screen 4.png')
const screen5 = require('./screen 5 FN.png')

export default [screen1, screen2, screen3, screen4, screen5]
